module.exports = __webpack_public_path__ + "img/landing-image.3c40f6f7.png";